import AuthenticationActions from "../actions/AuthenticationActions";
import { baseUrl } from "./config";
import request from "superagent";

let instance = null;

class AuthenticationApi {
  constructor() {
    if (!instance) {
      instance = this;
    }

    return instance;
  }

  login(user) {
    if (localStorage.token) {
      AuthenticationActions.authenticationChanged();
      return;
    }

    request
      .post(`${baseUrl}login`)
      .send({ ...user, appType: "ticket" })
      .set("Accept", "application/json")
      .type("json")
      .end(function (err, res) {
        if (res.ok) {
          if (res.body.token) {
            localStorage.token = res.body.token;
          }
          if (res.body.lang) {
            localStorage.lang = res.body.lang;
          }
          AuthenticationActions.authenticationChanged();
        } else {
          AuthenticationActions.authenticationChanged();
        }
      });
  }

  getLang() {
    return localStorage.lang;
  }

  setLang(lang) {
    if (lang) localStorage.lang = lang;
  }

  getToken() {
    return localStorage.token;
  }

  setToken(token) {
    if (token) localStorage.token = token;
  }

  logout(cb) {
    delete localStorage.token;
    delete localStorage.lang;
    AuthenticationActions.authenticationChanged();
  }

  loggedIn() {
    return !!localStorage.token;
  }
}

export default new AuthenticationApi();
